var React = require('react');

function LogoNhs (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"NHS Logo"),React.createElement("path",{"d":"M98 39V0H0v39h98zM39.4 3.76l-6.77 31.39h-10.6L15.3 13.43l-4.44 21.72H2.78L9.6 3.75h10.67l6.54 21.78h.08l4.49-21.77h8.03zm30.37 0l-6.63 31.39h-8.55l2.78-13.44H47.34l-2.79 13.44h-8.63l6.64-31.4h8.55l-2.5 12.02H58.7l2.52-12.01h8.55zm24.57.86l-2.06 6.25a16.49 16.49 0 00-7.05-1.38c-3.38 0-6.12.48-6.12 3.01 0 4.45 12.39 2.76 12.39 12.32 0 8.68-8.19 10.93-15.6 10.93a36.3 36.3 0 01-9.88-1.62l2.02-6.4a16.75 16.75 0 007.87 1.8c2.64 0 6.8-.49 6.8-3.72 0-5.04-12.39-3.15-12.39-12 0-8.1 7.23-10.54 14.23-10.54 3.3-.15 6.62.31 9.75 1.38l.04-.03z","fill":"#005EB8","key":1})]);
}

LogoNhs.defaultProps = {"viewBox":"0 0 98 39","fill":"none"};

module.exports = LogoNhs;

LogoNhs.default = LogoNhs;
